import React, { useContext, useCallback } from 'react';

import { PolicyCheckbox as PolicyCheckboxComponent } from '../../../../components/ui/Inputs/PolicyCheckbox';
import { useEvent } from '../../../../utils/analytics/useEvent';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function PolicyCheckbox() {
  const trackEvent = useEvent();
  const { bindPolicy, isLoading } = useContext(MlifeAccountSetupContext);

  const onRulesClick = useCallback(() => {
    trackEvent('identity – mlife account setup - external link click', 'program rules', 'mlifeaccountsetupclicks');
  }, [trackEvent]);

  const onPolicyClick = useCallback(() => {
    trackEvent('identity – mlife account setup - external link click', 'privacy policy', 'mlifeaccountsetupclicks');
  }, [trackEvent]);

  return (
    <PolicyCheckboxComponent
      onPolicyClick={onPolicyClick}
      onRulesClick={onRulesClick}
      disabled={isLoading}
      {...bindPolicy}
    />
  );
}

PolicyCheckbox.displayName = 'PolicyCheckboxField';
